import ContentContainer from '@/features/shared/ContentContainer';
import { MuiContainer, MuiTypography } from '@/features/shared/material-ui';
import { InsetTop, SpacingSizes, Theme } from '@/utils/constants';
import clsx from 'clsx';
import React, { memo, useMemo } from 'react';
import { FeaturedContentProps } from '../FeaturedContent.interface';
import { ColumnCard } from '../shared/ColumnCard';
import { CtaCard } from '../shared/CtaCard';
import useStyles from './Column.styles';

const getFeatureContent = ({ contentList }: ContentListType): CardType => {
  const card = contentList && contentList.find((item: any) => item.featuredContent);
  return card as CardType;
};

const CardVariant = ({ card, styles, hideImage }: any) => {
  if (/image/.test(card.variant)) {
    return <CtaCard cardImage={card.image} {...styles} />;
  }

  return <ColumnCard {...card} {...styles} hideImage={hideImage} cardImageType="card" />;
};

const Column = ({
  curatedList,
  contentButtons,
  cardColor,
  theme = Theme.light,
  presentation,
  cardTheme,
  isCardImages,
}: FeaturedContentProps) => {
  const classes = useStyles({});
  const { contentList = [], listSuperheading, listTitle } = curatedList || {};
  const featuredContentCard = useMemo(() => getFeatureContent({ contentList }), [contentList]);
  const filterList = useMemo(
    () =>
      featuredContentCard && contentList
        ? contentList.filter((item: any) => item?.cardHeading !== featuredContentCard?.cardHeading)
        : contentList,
    [contentList, featuredContentCard],
  );

  const { topSpacing, bottomSpacing, topBackgroundColor, bottomBackgroundColor } =
    presentation || {};

  const styles = {
    cardColor,
    cardTheme,
    theme,
  };

  const hasHeadings = listSuperheading || listTitle;
  const hasTopContent = hasHeadings || featuredContentCard;
  return (
    <>
      {hasTopContent && (
        <ContentContainer
          topSpacing={topSpacing}
          bottomSpacing={SpacingSizes.small}
          topBackgroundColor={topBackgroundColor}
          bottomBackgroundColor={topBackgroundColor}
        >
          <MuiContainer>
            {contentButtons?.curatedList}
            {(listSuperheading || listTitle) && (
              <div className={clsx(classes.headerCard, `${theme}-theme`)}>
                {listSuperheading && (
                  <MuiTypography
                    variant="overline"
                    component="div"
                    className={classes.superHeading}
                  >
                    {listSuperheading}
                  </MuiTypography>
                )}
                {listTitle && (
                  <MuiTypography variant="h4" component="h4" className={classes.title}>
                    {listTitle}
                  </MuiTypography>
                )}
              </div>
            )}
            {featuredContentCard && (
              <ColumnCard
                {...featuredContentCard}
                cardColor={cardColor}
                cardTheme={cardTheme}
                theme={theme}
                isFeaturedContent
              />
            )}
          </MuiContainer>
        </ContentContainer>
      )}

      {filterList.length > 0 && (
        <ContentContainer
          bottomSpacing={bottomSpacing}
          topSpacing={SpacingSizes.small}
          topBackgroundColor={topBackgroundColor}
          bottomBackgroundColor={bottomBackgroundColor}
          insetTop={InsetTop.featuredContent}
        >
          <MuiContainer className={clsx(classes.cards, 'medium')}>
            {!hasTopContent && contentButtons?.curatedList}
            {filterList.map((card: any, idx: any) => {
              return (
                <CardVariant
                  // eslint-disable-next-line react/no-array-index-key
                  key={`card_${idx}`}
                  card={card}
                  styles={styles}
                  hideImage={!isCardImages}
                />
              );
            })}
          </MuiContainer>
        </ContentContainer>
      )}
    </>
  );
};

export default memo(Column);
